import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Quality'

  }
];

@Component({
  selector: 'page-qc-check-sheet',
  templateUrl: './form-qc-check-sheet.html',
  styleUrls: ['./form-qc-check-sheet.scss']
})

export class PageQcCheckSheet implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;
  key:any;  data:any;
  lines=[];  prods=[]; checkpoints=[];valuesFirst=[];valuesMidle=[];valuesEnd=[];
  tpr_id:String;tpn_id:String;
  lineName:String;processName:String;
   rowsSpan:any=0;
  //dialog
  dialogRefWarning: MdDialogRef<WarningPdCheckSheetDialog>;
  dialogRef: MdDialogRef<pdCheckSheetDialog>;
  setId:any;
  dateTime:any;date_selected:any;
  fpoint=[];  mpoint=[];  epoint=[];
  firstCheck:boolean=false;middleCheck:boolean=false;endCheck:boolean=false;
  operatorName:String;prodDate:String;operatorId:String;tb87f_id:String;tb106f_id:String;
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    this.dateTime=Date.now();
    let date = new Date();
    this.date_selected = date.toISOString().split('T')[0];this.getlines();
    this.fullScreen();
    this._sharedService.emitChange(this.pageTitle);
    this.dialog.closeAll();
  }

  fullScreen() {
    let elem = document.documentElement;
    let methodToBeInvoked = elem.requestFullscreen || elem['mozRequestFullscreen']
      ||
      elem['msRequestFullscreen'];
    if (methodToBeInvoked) methodToBeInvoked.call(elem);
}
  getOperator(){
      this.httpservice.fetchget('getJSON_production_operator.php?tpr_id='+this.tpr_id+'&tpn_id='+this.tpn_id,data=>{
        this.operatorName = data[0].operator_name;
        this.prodDate = data[0].planDate;
        this.operatorId = data[0].operator_id;
        
        console.log('operator',data);
      });
  }

  getCheckPoint(){
      this.httpservice.fetchget('getJSON_mobile_standard_list.php?tpr_id='+this.tpr_id+'&tpn_id='+this.tpn_id,data=>{
        this.checkpoints = data;
        console.log('data',data);
        //    this.rowsSpan= data['process'].length;
      
        
      });
  }

  Onchange(e:any){


    console.log('onchange',e,this.firstCheck);
  }
  intervalGetData(){
    
    return setInterval(() => {
      if(this.setId.runCount>5){
        clearInterval(this.setId);
        }
      //this.getStartData();
      console.log('------this.setId------',this.setId);
     }, 1000);

  }
  getlines(){
    this.httpservice.fetchget('getJSON_line_name.php?',data=>{
        this.lines = data;
      
      });
  }
  getProcess(id:String,name:string){
    this.tpn_id = id;
    this.processName=name;
    this.getCheckPoint();
    this.getOperator();

  }
  getProcessInLine(id:String,name:string){
    this.tpr_id = id;
    this.lineName = name;
    this.httpservice.fetchget('getJSON_process_name.php?tpr_id='+id,data=>{
      this.prods = data;

      console.log('prods',data);

    });
  }

  getValueInputFirst(value:String,tb87f_id:String,index:any,tb106f_id:String){
      this.valuesFirst[index] = {value:value,spec:tb87f_id,point:tb106f_id};
      console.log('value',this.valuesFirst);
  }

  getValueInputMidle(value:String,tb87f_id:String,index:any,tb106f_id:String){
    this.valuesMidle[index] = {value:value,spec:tb87f_id,point:tb106f_id};
    console.log('value',this.valuesMidle);
}


getValueInputEnd(value:String,tb87f_id:String,index:any,tb106f_id:String){
    this.valuesEnd[index] = {value:value,spec:tb87f_id,point:tb106f_id};
    console.log('value',this.valuesEnd);
}

save(){

    let value = {tpr_id:this.tpr_id,tpn_id:this.tpn_id,type:"2",valuesFirst:this.valuesFirst,
    valuesMidle:this.valuesMidle,valuesEnd:this.valuesEnd,
    firstCheck:this.firstCheck,middleCheck:this.middleCheck,endCheck:this.endCheck,
    user:this.operatorId};
    this.httpservice.fetchpost('insertDataMobile_check_point.php',value,(cb)=>{});
}


search(){

  }

  ngOnInit() {

  }

}
//dialog
@Component({
  selector: 'pd-check-sheet-dialog',
  templateUrl: 'dialog.html',
})
export class pdCheckSheetDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<pdCheckSheetDialog>) {}
}

//warning
@Component({
  selector: 'warning-pd-check-sheet-dialog',
  templateUrl: 'warning.html',
})
export class WarningPdCheckSheetDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningPdCheckSheetDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/mobile/form-qc-check-sheet.ts